
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3159"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3159"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bCIFA", function(module, exports) {

$parcel$export(module.exports, "register", () => $8765e4c924822d27$export$6503ec6e8aabbaf, (v) => $8765e4c924822d27$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $8765e4c924822d27$export$f7ad0328861e2f03, (v) => $8765e4c924822d27$export$f7ad0328861e2f03 = v);
var $8765e4c924822d27$export$6503ec6e8aabbaf;
var $8765e4c924822d27$export$f7ad0328861e2f03;
"use strict";
var $8765e4c924822d27$var$mapping = new Map();
function $8765e4c924822d27$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8765e4c924822d27$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8765e4c924822d27$var$resolve(id) {
    var resolved = $8765e4c924822d27$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8765e4c924822d27$export$6503ec6e8aabbaf = $8765e4c924822d27$var$register;
$8765e4c924822d27$export$f7ad0328861e2f03 = $8765e4c924822d27$var$resolve;

});

var $34b9574138b965c1$exports = {};

(parcelRequire("bCIFA")).register(new URL("", import.meta.url).toString(), JSON.parse('["8EWj8","index.541c99f8.js","aFCLs","About.4d72ca8a.js"]'));


//# sourceMappingURL=index.runtime.1d0ed377.js.map
